import { useRuntimeConfig } from '#imports'

import type { MarketCountryCode } from '@backmarket/http-api/src/api-models/MarketCountryCode'
import { addTrailingSlash } from '@backmarket/utils/url/addTrailingSlash'
import { removeLeadingSlash } from '@backmarket/utils/url/removeLeadingSlash'

const toPublicPath = (path: string) => {
  const config = useRuntimeConfig()

  return config.app?.cdnURL
    ? new URL(removeLeadingSlash(path), addTrailingSlash(config.app.cdnURL))
        .href
    : path
}

export type DidomiConfig = {
  user: {
    bots?: {
      consentRequired: boolean
    }
    country?: string
    region?: string
  }
  cookies: {
    storageSources: {
      cookies: boolean
      localStorage: boolean
    }
  }
  app: {
    logoUrl: string
  }

  notice: {
    learnMorePosition: 'after' | 'before'
    textAlignment: 'left' | 'center' | 'right'
    enable: boolean
  }
}

export const getDidomiConfig = (
  countryCode: MarketCountryCode,
): DidomiConfig => {
  const { countriesWithNoCookieOptIn } = useRuntimeConfig().public.tracking

  return {
    user: { bots: { consentRequired: false } },
    cookies: {
      storageSources: {
        cookies: true,
        localStorage: false,
      },
    },
    app: {
      logoUrl: toPublicPath('/img/legal/cookies.png'),
    },
    notice: {
      learnMorePosition: 'after',
      textAlignment: 'center',
      enable: !countriesWithNoCookieOptIn.includes(countryCode),
    },
  }
}

export const VENDORS_ID = {
  amplitude: 'amplitude-nzaqxfRQ',
  braze: 'braze-x4LHJX93',
  gtm: 'googletag-Et9AC4np',
  appsFlyer: 'appsflyer-Gi8QYXZh',
} as const

export const DIDOMI_COOKIE_NAME = 'euconsent-v2'
